"use strict";

const MENU_ICONS = document.querySelectorAll(".lac-menu-icon");
const RESULTS = document.querySelectorAll(".lac-result");
const RESULT_CLASSES = new Set();

const addActiveClassStep1 = (icon) => {
  const step_1_Classes = [MENU_ICONS[0], MENU_ICONS[1]];
  [...step_1_Classes].forEach((icon) => {
    icon.classList.remove("active");
  });

  icon.classList.add("active");
};

const addActiveClassStep2 = (icon) => {
  const step_2_Classes = [MENU_ICONS[2], MENU_ICONS[3]];
  [...step_2_Classes].forEach((icon) => {
    icon.classList.remove("active");
  });

  icon.classList.add("active");
};

const addActiveClassStep3 = (icon) => {
  const step_3_Classes = [MENU_ICONS[4], MENU_ICONS[5]];
  [...step_3_Classes].forEach((icon) => {
    icon.classList.remove("active");
  });

  icon.classList.add("active");

  if (window.innerWidth < 768) {
    document
      .querySelector("#lac-results-divider")
      .scrollIntoView({ behavior: "smooth" });
  }
};

const updateResults = () => {
  /* Iterates over each result element.
   * For each result, it checks if all classes in the setToArray are present in the result's class list.
   * If all classes are not present, it removes the 'active' class from the result.
   * If all classes are present, it adds the 'active' class to the result.
   * If no classes are in the setToArray, all results are shown. */
  const setToArray = Array.from(RESULT_CLASSES);
  RESULTS.forEach((result) => {
    if (!setToArray.every((cls) => result.classList.contains(cls))) {
      result.classList.remove("active");
    }
    if (setToArray.every((cls) => result.classList.contains(cls))) {
      result.classList.add("active");
    }
  });

  // Check if any result has the 'active' class. If not, show the no results message.
  const noResultsMessage = document.getElementById("lac-no-results-message");
  const hasActiveResult = Array.from(RESULTS).some((result) =>
    result.classList.contains("active"),
  );
  if (hasActiveResult) {
    noResultsMessage.style.display = "none";
  } else {
    noResultsMessage.style.display = "block";
  }
};

const updateResultActiveState = (classToRemove) => {
  /*Checks if the RESULT_CLASSES set has a certain class. If it does, it removes it. Used to toggle
  between menu options by only showing active on the clicked menu icon. */
  if (RESULT_CLASSES.has(classToRemove)) {
    RESULT_CLASSES.delete(classToRemove);
  }
};

const showResults = () => {
  MENU_ICONS.forEach((option) => {
    option.addEventListener("click", (e) => {
      if (e.target.classList.contains("lac-single-zone-icon")) {
        updateResultActiveState("lac-multi-zone"); // Removes other classes from RESULT_CLASSES in the same category (step 1, 2 etc.)
        RESULT_CLASSES.add("lac-single-zone"); // Adds this class to RESULT_CLASSES
        addActiveClassStep1(MENU_ICONS[0]);
        updateResults(); // Updates the shown results based on the classes in RESULT_CLASSES
      } else if (e.target.classList.contains("lac-multi-zone-icon")) {
        updateResultActiveState("lac-single-zone");
        addActiveClassStep1(MENU_ICONS[1]);
        RESULT_CLASSES.add("lac-multi-zone");
        updateResults();
      } else if (e.target.classList.contains("lac-standard-icon")) {
        updateResultActiveState("lac-ip44");
        addActiveClassStep2(MENU_ICONS[2]);
        RESULT_CLASSES.add("lac-standard");
        updateResults();
      } else if (e.target.classList.contains("lac-iprated-icon")) {
        updateResultActiveState("lac-standard");
        addActiveClassStep2(MENU_ICONS[3]);
        RESULT_CLASSES.add("lac-ip44");
        updateResults();
      } else if (e.target.classList.contains("lac-bluetooth-icon")) {
        updateResultActiveState("lac-wifi");
        addActiveClassStep3(MENU_ICONS[4]);
        RESULT_CLASSES.add("lac-bluetooth");
        updateResults();
      } else if (e.target.classList.contains("lac-wifi-icon")) {
        updateResultActiveState("lac-bluetooth");
        addActiveClassStep3(MENU_ICONS[5]);
        RESULT_CLASSES.add("lac-wifi");
        updateResults();
      }
    });
  });
};
showResults();

const moreInfoAccordion = () => {
  // Accordion for more info section on the results.
  const moreInfoButtons = document.querySelectorAll(".lac-more-info-button");
  const moreInfoContent = document.querySelectorAll(".lac-more-info-content");

  moreInfoButtons.forEach((button, i) => {
    button.addEventListener("click", () => {
      moreInfoContent[i].classList.toggle("active");
    });
  });
};
moreInfoAccordion();
